<template>
  <footer>
    <v-container>
      <a
        href="https://bredi.com.br/"
        class="text-black"
        target="_blank"
        rel="noopener nofollow noreferrer"
      >
        Desenvolvido por Bredi

        <v-icon name="bredi" size="33px" class="ml-2" color="true"></v-icon>
      </a>
    </v-container>
  </footer>
</template>

<style scoped lang="scss">
  @import '@sass/global/mixins';
  @import '@sass/global/functions';

  footer {
    padding-block: 16px;
    text-align: right;
  }
</style>
